import { Flex } from 'antd';
import { useContext } from 'react';
import { SymptomCardData } from '../types';

/**
 * Styles that can only be done in CSS go in here
 */
import { BrainFunctionBarChart } from './graph-brainfunction-barchart';
import { SymptomCard2Context } from '../symptom-card-2';

export function HistoricalStatus(props: {
  sortedData: SymptomCardData[];
  scale: number[];
  colors: string[];
}) {
  const ctx = useContext(SymptomCard2Context);
  return (
    <Flex justify={'center'}>
      <BrainFunctionBarChart
        maxAssessments={7}
        data={props.sortedData}
        scale={props.scale}
        colors={props.colors}
        width={200}
        barThickness={15}
        showLabels
        showValues={ctx.showNumbers}
      />
    </Flex>
  );
}
